const cities = [
  { name: "Wesley Chapel", zips: "33543, 33544, 33545" },
  { name: "New Tampa", zips: "33647" },
  { name: "Land O' Lakes", zips: "34638, 34639" },
  { name: "Lutz", zips: "33548, 33549, 33558, 33559" },
  { name: "Zephyrhills", zips: "33539, 33540, 33541, 33542" },
  { name: "Dade City", zips: "33523, 33525, 33526" },
  { name: "Odessa", zips: "33556" },
  { name: "Trinity", zips: "34655" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function WesleyChapelLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Wesley Chapel & Northern Tampa Bay
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Wesley Chapel, Wiregrass Ranch, New Tampa, or anywhere in northern Pasco County, Fast Passport Center makes expedited passport processing simple — no drive downtown, no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Wesley Chapel is not a sleepy rural crossroads anymore — it is one of the fastest-growing communities in the entire state of Florida. Located in northern Pasco County along Interstate 75, Wesley Chapel has exploded from a quiet citrus and cattle town into a thriving suburban hub of roughly 65,000 residents. The Wiregrass Ranch master-planned community, anchored by The Shops at Wiregrass outdoor mall, brought national retail, upscale dining, and a modern suburban identity to what was once farmland. AdventHealth Wesley Chapel (formerly Florida Hospital Wesley Chapel) and the nearby Pasco-Hernando State College campus have brought medical professionals, educators, and students into the community, while new residential developments continue to expand the population north and east toward Dade City and Zephyrhills.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What makes Wesley Chapel unique is its demographic profile. Unlike coastal Florida cities that draw retirees and seasonal residents, Wesley Chapel is predominantly young families, professionals commuting to Tampa, and military families connected to MacDill Air Force Base. The median age skews younger than most Florida communities. Schools in the area — including Wiregrass Ranch High School, Wesley Chapel High School, and the rapidly growing charter school network — are full of children whose parents are at the exact life stage where international travel matters: spring break trips, summer vacations to Europe, student exchange programs, and family cruises. This is precisely the demographic most likely to discover a passport has expired at the worst possible moment.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The Tampa Bay Lightning and Tampa Bay Buccaneers draw sports fans from Wesley Chapel to Raymond James Stadium and Amalie Arena, but the travel patterns are broader than local sports. Wesley Chapel families fly out of Tampa International Airport (TPA) — only about 25 miles south on I-275 — for Caribbean cruises, European vacations, and trips to visit family abroad. The Wiregrass Sports Campus and the Tampa Bay Skating Academy attract youth sports teams that travel to national and international competitions. Parents of competitive gymnasts, hockey players, and soccer athletes regularly discover that a child's passport expires between competition seasons.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Wesley Chapel's geographic position matters too. It sits at the intersection of I-75 and State Road 56, with easy access to both Tampa and Orlando. But that accessibility does not extend to passport services. The closest regional passport agency is in Miami — a four-hour drive south. The post offices in Wesley Chapel, Land O' Lakes, and Zephyrhills offer standard passport acceptance services, but with the same 2–6 month processing times that frustrate travelers nationwide. For a Wesley Chapel parent who discovers their child's passport expired three weeks before a booked Caribbean cruise, those timelines are useless.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for Wesley Chapel travelers across every demographic — young families booking Disney cruises, medical professionals flying to conferences in Europe, military families with emergency deployment travel, and student athletes heading to international competitions. Our courier-based expedited service means you start online from your Wesley Chapel home, your office at AdventHealth, or your car after school pickup — and your passport arrives within days, not months.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Serving Wesley Chapel</p>
                  <p className="text-white/60 text-xs mt-0.5">Remote service — start online, ship overnight</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office in Delray Beach — but you don't need to visit
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Pasco and Hillsborough Counties</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location at The Shops at Wiregrass or along Bruce B. Downs, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities & Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Pasco, Hillsborough, or northern Tampa Bay — start online, ship overnight, and we handle the rest. No need to drive to Tampa or Miami.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Tampa", href: "/tampa" },
                  { name: "St. Petersburg", href: "/st-petersburg" },
                  { name: "Clearwater", href: "/clearwater" },
                  { name: "Lakewood Ranch", href: "/lakewood-ranch" },
                  { name: "Sarasota", href: "/sarasota" },
                  { name: "Orlando", href: "/orlando" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}